import React from 'react'
import { Link } from 'react-router-dom'
// import _ from 'lodash'
import { connect } from 'react-redux'
import { fetchFMProgramsIfNeeded, fetchZDProgramsIfNeeded } from '~/programs/actions'

class AmrapPages extends React.Component {
  constructor() {
    super()
    this.state = {
      programsFM: [],
      programsZD: []
    }
  }

  componentDidMount() {
    const {dispatch} = this.props
    dispatch(fetchFMProgramsIfNeeded())
    dispatch(fetchZDProgramsIfNeeded())
    //window.amrapApi_load()
  }

  componentWillUpdate(nextProps) {
    // const { location } = this.props
    // if (this.props.location !== nextProps.location) {
    //   console.log('updating amrapApi')
    //   window.amrapApi_load && window.amrapApi_load()
    // }

  }

  render() {
    const {match, programsFM, programsZD} = this.props
    let programsZED = []
    if (programsFM.items && programsFM.items.length > 0 && programsZD.items && programsZD.items.length > 0 ) {
       programsZED = programsFM.items.concat(programsZD.items)
    }
    // programsZED = _.sortBy( programsZED, function (i) { return i.name.toLowerCase() } )
    // programsZED = programsZED.sort( (a, b) => a.name.toLowerCase() > b.name.toLowerCase() );
    programsZED = programsZED.sort( (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()) );
    // programsZED = _.uniq(programsZED, 'name')
    programsZED = programsZED.filter((item, pos, self) => self.findIndex(v => v.name === item.name) === pos);
    const amrapPrograms = programsZED.map((fm, index) =>
      <div key={index}>
        <h3>
          <a style={{color:'white'}} href={`https://4zzz.org.au/amrap/${fm.slug}`}>{fm.name}</a>
        </h3>
      </div>
    )
    if(match.params.id){
      return (
        <div className="content">
          <h2>Announcers Amrap Pages</h2>
          <div id="amrap-page" style={{background: 'white'}}>
          </div>
        </div>
      )
    }
    else {
      return (
        <div className="content">
          <h2>Announcers Amrap Pages</h2>
          {amrapPrograms}
        </div>
      )
    }
  }
}

export default connect(state => {return { programsFM: state.programsFM, programsZD: state.programsZD } }) (AmrapPages)
